<template>
    <div class="col-xl-5 des-xl-100 box-col-100 col-lg-12">
        <div class="card investment-chart">
            <div class="card-body">
                <div class="row">
                    <div class="col-sm-4">
                        <div class="investment-group"><span class="invest-lable">+13.6%</span>
                            <apexchart type="line" height="108" :options="invest.options" :series="invest.series">
                            </apexchart>
                            <div class="chart-detail">
                                <h5>Total Investment</h5>
                                <h2>$7454.25</h2>
                            </div>
                        </div>
                    </div>
                    <gainChart />
                    <profitChart />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import gainChart from "./gainChart.vue"
import profitChart from "./profitChart.vue"
var primary = localStorage.getItem('primary_color') || '#534686';
export default {
    components: { gainChart, profitChart },
    data() {
        return {
            invest: {
                options: {
                    chart: {
                        height: 108, type: "line",
                        zoom: {
                            enabled: false,
                        },
                        toolbar: {
                            show: false,
                        },
                    },
                    dataLabels: {
                        enabled: false,
                    },
                    stroke: {
                        curve: "smooth",
                    },
                    legend: {
                        show: false,
                    },
                    grid: {
                        show: false,
                    },
                    colors: [primary],
                    xaxis: {
                        axisBorder: {
                            show: false,
                        },
                        labels: {
                            show: false,
                        },
                        axisTicks: {
                            show: false,
                        },
                        crosshairs: {
                            show: true, width: 1, position: "back",
                            stroke: {
                                color: primary, width: 1, dashArray: 5,
                            },
                        },
                        tooltip: {
                            enabled: false,
                        },
                    },
                    tooltip: {
                        marker: {
                            show: false,
                        },
                        fixed: {
                            enabled: false,
                            position: "bottomRight",
                            offsetX: 0, offsetY: 0,
                        },
                    },
                    yaxis: {
                        labels: {
                            show: false,
                        },
                    },
                },
                series: [{
                    name: "Desktops",
                    data: [5, 20, 5, 50, 25, 50, 20, 60],
                },],
            }
        }
    }
}
</script>